<div [ngClass]="getClosingHourClass(businessHours)" class="closing-hour">
    <span class="hide"> {{ locationLabels.hours }}:</span><span>{{ getFilterClosingHours(getClosingHour(businessHours)) }}</span>
</div>
